<template>
  <div class="reset-password-page h-screen">
    <div class="container h-full">
      <div class="row items-center h-full">
        <div class="_col col-12 md:col-1/3 md:offset-1/3">
          <div class="reset-password-page__logo py-5">
            <VPLogo class="m-auto" />
          </div>

          <div class="reset-password-page__form py-5">
            <FormResetPassword />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Components */
import FormResetPassword from '@/components/FormResetPassword.vue'
import VPLogo from '@/assets/images/VP-Logo.svg'

export default {
  components: {
    FormResetPassword,
    VPLogo,
  },
}
</script>
